export default __webpack_public_path__ + "static/media/undraw_selection.b7ae9436.svg";